import { gql } from "@apollo/client";

import { SEARCH_SUGGESTIONS_FRAGMENT } from "constants/suggestions";

export const SEARCH_WORKER_POOLS = gql`
  query SearchWorkerPools($input: SearchInput!) {
    publicWorkerPool {
      parallelism
      busyWorkers
      schedulableRunsCount
    }
    searchWorkerPools(input: $input) {
      edges {
        cursor
        node {
          id
          name
          description
          spaceDetails {
            id
            name
            accessLevel
          }
          allowedActions
          labels
          driftDetectionRunLimit
          busyWorkers
          schedulableRunsCount
          usersCount
          workersCount
          managedByK8sController
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const SEARCH_WORKER_POOLS_SUGGESTIONS = gql`
  query SearchWorkerPoolsSuggestions($input: SearchSuggestionsInput!) {
    searchWorkerPoolsSuggestions(input: $input) {
      ...SearchSuggestionsFragment
    }
  }
  ${SEARCH_SUGGESTIONS_FRAGMENT}
`;

export const CREATE_WORKER_POOL = gql`
  mutation CreateWorkerPool(
    $name: String!
    $description: String
    $certificateSigningRequest: String!
    $labels: [String!]
    $space: ID
    $driftDetectionRunLimit: Int
  ) {
    workerPoolCreate(
      name: $name
      description: $description
      certificateSigningRequest: $certificateSigningRequest
      labels: $labels
      space: $space
      driftDetectionRunLimit: $driftDetectionRunLimit
    ) {
      config
      workerPool {
        id
        name
      }
    }
  }
`;

export const UPDATE_WORKER_POOL = gql`
  mutation UpdateWorkerPool(
    $id: ID!
    $name: String!
    $description: String
    $labels: [String!]
    $space: ID
    $driftDetectionRunLimit: Int
  ) {
    workerPoolUpdate(
      id: $id
      name: $name
      description: $description
      labels: $labels
      space: $space
      driftDetectionRunLimit: $driftDetectionRunLimit
    ) {
      workerPool {
        id
        name
      }
    }
  }
`;

export const DELETE_WORKER_POOL = gql`
  mutation DeleteWorkerPool($workerPoolId: ID!) {
    workerPoolDelete(id: $workerPoolId) {
      id
      name
    }
  }
`;

export const RESET_WORKER_POOL = gql`
  mutation ResetWorkerPool($workerPoolId: ID!, $certificateSigningRequest: String!) {
    workerPoolReset(id: $workerPoolId, certificateSigningRequest: $certificateSigningRequest) {
      config
    }
  }
`;

export const CYCLE_WORKER_POOL = gql`
  mutation CycleWorkerPool($workerPoolId: ID!) {
    workerPoolCycle(id: $workerPoolId)
  }
`;
